import React, {useState} from "react";
import {
  FacebookIcon,
  FacebookShareButton,
  LinkedinIcon,
  LinkedinShareButton,
  TelegramIcon,
  TelegramShareButton,
  TwitterIcon,
  TwitterShareButton,
  WhatsappIcon,
  WhatsappShareButton
} from "react-share";
import styled from "styled-components";
import { Save, Close, FilterNone, InfoOutlined } from '@material-ui/icons'
import localization from "../../../config/localization";
import { Dialog, DialogContent, DialogTitle, IconButton, TextField, Tooltip } from "@material-ui/core";
import {CopyToClipboard} from "react-copy-to-clipboard";
import {makeStyles} from "@material-ui/styles";
import GlobalSnackbar, {GlobalSnackbarTypes} from "../Snackbar/GlobalSnackbar";
import {request} from "../../../api-client";


const ShareSocialContainer = styled.div`
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 0;
  margin: 0;
  list-style: none;
  @media (max-width: 479px) {
    min-width: 270px;
  }
  @media (min-width: 479px) {
    min-width: 400px;
  }
`

const DialogSocialContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export default ({show, url, handleClose, darkMode = false, title = localization.get("share"), shareToken = "", hideReceiver = false, onClick = null}) => {
  const [receiver, setReceiver] = useState( '' );
  const classes = makeStyles((theme) =>  ({
      root: {
        [theme.breakpoints.down("xs")]: {
          alignItems: "flex-end!important" // push the dialog to bottom
        }
      },
      paper: {
        // make the content full width
        [theme.breakpoints.down("xs")]: {
          margin: 0,
          maxWidth: "100%",
          width: "100%"
        }
      }
    }))
  const copyStringToClipboard = (text) => {
    if (!navigator.clipboard) {
      fallbackCopyTextToClipboard(text);
      return;
    }
    navigator.clipboard.writeText(text).then(function() {
      console.log('Async: Copying to clipboard was successful!');
    }, function(err) {
      console.error('Async: Could not copy text: ', err);
    });
  };

  const fallbackCopyTextToClipboard = (text) =>  {
    var textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();

    try {
      var successful = document.execCommand('copy');
      var msg = successful ? 'successful' : 'unsuccessful';
      console.log('Fallback: Copying text command was ' + msg);
    } catch (err) {
      console.error('Fallback: Oops, unable to copy', err);
    }

    document.body.removeChild(textArea);
  };

  const saveReceiver = () => {
      if (!receiver) {
        return;
      }
      return request.shareLink.update(shareToken, receiver)
        .then(() => GlobalSnackbar.show({message: localization.get('share.receiver_updated'), type: GlobalSnackbarTypes.SUCCESS }))
        .catch(() => GlobalSnackbar.showGenericError())
    }

  return(
    <Dialog
      classes={{ root: classes.root, paper: classes.paper }}
      open={show}
      onBackdropClick={handleClose}
      onEscapeKeyDown={handleClose}
      onClick={onClick ? (e) => onClick(e) : null}
    >
      <IconButton style={{ position: "absolute", top: "5px", right: "5px" }} onClick={handleClose}>
        <Close />
      </IconButton>
      <DialogTitle style={{background: darkMode ? "rgba(204, 204, 204, 0.5)" : "white"}} >{title}</DialogTitle>
      <DialogContent style={{background: darkMode ? "rgba(204, 204, 204, 0.5)" : "white"}}>
        <DialogSocialContainer>
          {!hideReceiver &&
            <div style={{display: 'flex', width: "100%", marginBottom: 30}}>
              <TextField
                style={{flex: 1}}
                label={localization.get('share.reference')}
                value={receiver}
                onChange={e => setReceiver(e.target.value)}
              />
              <div>
                {/* <IconButton onClick={() => {
                  if (!receiver) {
                    GlobalSnackbar.show({
                      message: localization.get('share.receiver_empty'),
                      type: GlobalSnackbarTypes.ERROR
                    });
                    return;
                  }
                  saveReceiver()
                }}>
                  <Tooltip title={localization.get('share.set_receiver')} placement="top">
                    <Save/>
                  </Tooltip>
                </IconButton> */}
                <IconButton>
                  <Tooltip title={localization.get('share.receiver_info')} placement="top">
                    <InfoOutlined/>
                  </Tooltip>
                </IconButton>
              </div>
            </div>
          }
          <ShareSocialContainer>
            <CopyToClipboard style={{width: window.innerWidth < 479 ? 40 : 60, height: window.innerWidth < 479 ? 40 : 60, background: darkMode ? "black" : "#ccc"}} onCopy={() => {saveReceiver(); copyStringToClipboard(url)}}>
              <IconButton round={true} bgStyle={{fill: "black"}}>
                <Tooltip title={localization.get('copy_link')} placement="top">
                  <FilterNone style={{fontSize: window.innerWidth < 479 ?  20 : 36, zIndex: 2, color: "white"}}/>
                </Tooltip>
              </IconButton>
            </CopyToClipboard>
            <WhatsappShareButton url={url} onClick={saveReceiver}>
              <WhatsappIcon size={window.innerWidth < 479 ? 40 : 60} round={true} bgStyle={{fill: darkMode ? "black" : ""}}/>
            </WhatsappShareButton>
            <TwitterShareButton url={url} onClick={saveReceiver}>
              <TwitterIcon size={window.innerWidth < 479 ? 40 : 60} round={true} bgStyle={{fill: darkMode ? "black" : ""}}/>
            </TwitterShareButton>
            <FacebookShareButton url={url} onClick={saveReceiver}>
              <FacebookIcon size={window.innerWidth < 479 ? 40 : 60} round={true} bgStyle={{fill: darkMode ? "black" : ""}}/>
            </FacebookShareButton>
            <LinkedinShareButton url={url} onClick={saveReceiver}>
              <LinkedinIcon size={window.innerWidth < 479 ? 40 : 60} round={true} bgStyle={{fill: darkMode ? "black" : ""}}/>
            </LinkedinShareButton>
            <TelegramShareButton url={url} onClick={saveReceiver}>
              <TelegramIcon size={window.innerWidth < 479 ? 40 : 60} round={true} bgStyle={{fill: darkMode ? "black" : ""}}/>
            </TelegramShareButton>
          </ShareSocialContainer>
        </DialogSocialContainer>
      </DialogContent>
    </Dialog>
  );
}

/*

const ShareSocialContainer = styled.div`
  background: rgba(255, 255, 255, 0.3);
  position: absolute;
  top: 65px;
  width: 200px;
  left: -24px;
  padding: 4px 4px 0px 4px;
  border-radius: 5px;
  transition: 0.3s;
`
render = () => {
  return(
    <ShareSocialContainer>
      <CopyToClipboard
        onCopy={() => this.setState({copied: localization.get('copied')})}
        onMouseEnter={() => this.setState({copied: localization.get('copy_link')})}
        text={this.props.url}
      >
        <IconButton style={{marginTop: "5px"}}>
          <Tooltip title={localization.get(this.state.copied)} placement="top">
            <FilterNone/>
          </Tooltip>
        </IconButton>
      </CopyToClipboard>
      <FacebookShareButton url={this.props.url} >
        <FacebookIcon size={32} round={true} bgStyle={{fill: "black"}}/>
      </FacebookShareButton>
      <LinkedinShareButton url={this.props.url} >
        <LinkedinIcon size={32} round={true} bgStyle={{fill: "black"}}/>
      </LinkedinShareButton>
      <TelegramShareButton url={this.props.url} >
        <TelegramIcon size={32} round={true} bgStyle={{fill: "black"}}/>
      </TelegramShareButton>
      <TwitterShareButton url={this.props.url} >
        <TwitterIcon size={32} round={true} bgStyle={{fill: "black"}}/>
      </TwitterShareButton>
      <WhatsappShareButton url={this.props.url} >
        <WhatsappIcon size={32} round={true} bgStyle={{fill: "black"}}/>
      </WhatsappShareButton>
    </ShareSocialContainer>
  );
}*/
